//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NoData from '../../NoData/NoData.vue';
export default {
    components: {
        NoData
    },
    props: ['list'],
    methods: {
        openUrl(url, group_id, groupbuy_id) {
            if (url == 'spellGroupDetail') {
                var test = {
                    group_id: group_id,
                    groupbuy_id: groupbuy_id,
                };
            } else {
                var test = {
                    tid: group_id,
                };
            };
            this.$router.push({
                name: url,
                params: test
            });
        }
    },
    filters: {
        status(val) {
            switch (val + "") {
                case "2":
                    return '拼团成功'
                    break;
                case "3":
                    return '拼团失败'
                    break;
                case "1":
                    return '待成团'
                    break;
                default:
                    return '拼团失败'
                    break;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/UserCenter/spellGroup/list.vue